import Joi from 'joi'

const emailSchema = Joi.object({
	email: Joi.string()
		.email({ tlds: { allow: false } })
		.required()
})
export const validateEmail = (email: string) => {
	const { error } = emailSchema.validate({ email })
	if (error) return error.details[0].message

	const domainError = validateEmailDomain(email)
	if (domainError) return domainError

	return undefined
}

export const validateEmailDomain = (email: string): string | undefined => {
	const domain = email.split('@')[1]
	if (!domain) return 'Invalid email domain'

	const parts = domain.split('.')
	if (parts.length < 2) return 'Invalid email domain'

	const tld = parts[parts.length - 1]
	if (!tld || tld.length < 2) return 'Invalid email domain'

	// Check for obviously invalid domains (no dots, single char TLD, numeric-only TLD)
	if (/^\d+$/.test(tld)) return 'Invalid email domain'

	return undefined
}

const passwordSchema = Joi.object({
	password: Joi.string()
		.pattern(new RegExp('^(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$'))
		.required()
		.messages({
			'string.pattern.base':
				'Password must be at least 8 characters long and contain at least one special character.'
		})
})

export const validatePassword = (password: string) => {
	const { error } = passwordSchema.validate({ password })
	return error ? error.details[0].message : undefined
}
